export type TrustTier = 'ghost' | 'starter' | 'active' | 'trusted' | 'pro';

export const TRUST_TIERS = {
  GHOST: 'ghost',
  STARTER: 'starter',
  ACTIVE: 'active',
  TRUSTED: 'trusted',
  PRO: 'pro',
} as const;

export const CATEGORIES = ['Development', 'Content', 'Video', 'Music', 'Community'] as const;
export type Category = (typeof CATEGORIES)[number];

export const FEE_RATE = 0.06;
export const STAKE_GATE = 5;
export const AUTO_RELEASE_MS = 72 * 3600 * 1000;

/** Stake thresholds per tier — trust is collateral, not KYC. */
export const TIER_STEPS: Array<{ tier: TrustTier; stake: number }> = [
  { tier: 'ghost', stake: 0 },
  { tier: 'starter', stake: 5 },
  { tier: 'active', stake: 10 },
  { tier: 'trusted', stake: 25 },
  { tier: 'pro', stake: 100 },
];

export function tierFor(staked: number): TrustTier {
  let t: TrustTier = 'ghost';
  for (const s of TIER_STEPS) if (staked >= s.stake) t = s.tier;
  return t;
}

/** Next tier up and the stake it needs, or null at Pro. */
export function nextTier(staked: number): { tier: TrustTier; stake: number } | null {
  for (const s of TIER_STEPS) if (staked < s.stake) return s;
  return null;
}

export function netAfterFee(amount: number): number {
  return Math.round(amount * (1 - FEE_RATE) * 10) / 10;
}
